import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card, Header, LoadingError } from "@kaladel/react/Components";
import { FC, useEffect, useMemo, useState } from "react";
import { Link } from "react-router";
import { DisplayCurrency } from "../DisplayCurrency";
import styles from "./HomeCards.module.scss";
import { useApp } from "AppContext";
import { AccountsOverviewGetResponse } from "ApiClient/models";
import { useApiClient } from "Contexts/ApiClientContext";

export const AccountsCard: FC = () => {
    const { api, apiCall } = useApiClient();
    const { activeCurrency } = useApp();

    const [accountsOverview, setAccountsOverview] = useState<AccountsOverviewGetResponse | null>(null);

    const refreshAccountsOverview = async () => {
        const response = await apiCall(() => api.accounts.overview.get());

        if (response.kind === "success") {
            setAccountsOverview(response.value);
        }
    };

    const currentCurrencyOverview = useMemo(() => {
        return accountsOverview?.balances.find(b => b.currencyId === activeCurrency);
    }, [accountsOverview, activeCurrency]);

    useEffect(() => {
        refreshAccountsOverview();
    }, []);

    if (!activeCurrency) return null;

    return (
        <Card>
            <Header title={<Link to="accounts">Accounts <FontAwesomeIcon icon={faChevronRight} /></Link>} level={1} />

            <LoadingError
                value={currentCurrencyOverview}
                loaded={currentCurrencyOverview => (
                    <div className={styles.breakdown}>
                        <div className={styles.line}>
                            <div className={styles.title}>
                                Total Balance
                            </div>
                            <div className={styles.percentage}></div>
                            <div className={styles.value}>
                                {currentCurrencyOverview !== undefined &&
                                    <DisplayCurrency currencyCode={activeCurrency} value={currentCurrencyOverview.balance} />
                                }
                            </div>
                        </div>
                    </div>
                )}
            />
        </Card>
    );
};